module.exports = __webpack_public_path__ + "img/1565035349.c0290339.jpg";